import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { Modal, Popover } from '@treams/treams-ui';

import TalentReviewTemplatePreview from './TalentReviewTemplatePreview';

export default function TalentReviewTemplatePreviewModal(props: {
	templateID: string;
	onClose: () => void;
}) {
	const { t } = useTranslation();
	const { onClose, templateID } = props;

	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key !== 'Escape') {
				return;
			}

			event.stopImmediatePropagation();
			onClose();
		};

		document.addEventListener('keydown', handleKeyDown, true);
		return () => document.removeEventListener('keydown', handleKeyDown, true);
	}, [onClose]);

	return (
		<Popover visible center zIndex={10} onDismiss={onClose}>
			<Modal width={800}>
				<Modal.Header
					title={t('common.settings.momentTemplates.edit.talentReviewGridPreview')}
					onClose={onClose}
				/>
				<Modal.Contents>
					<Flex justifyContent="center">
						<TalentReviewTemplatePreview templateID={templateID} />
					</Flex>
				</Modal.Contents>
			</Modal>
		</Popover>
	);
}
